import React from "react";
import { Chip } from "@mui/material";

// Chip de resumen de una tarjeta de automatización (triggers, enfriamiento, umbrales…).
const SummaryChip = ({ icon, label, color = "default", variant = "outlined" }) => (
    <Chip
        size="small"
        icon={icon}
        label={label}
        color={color}
        variant={variant}
        sx={{
            borderRadius: 999,
            "& .MuiChip-icon": { fontSize: 16 },
        }}
    />
);

export default SummaryChip;
